import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';

export interface AuthUser {
  email: string;
  name: string;
  id: string;
  tenantId: string;
}

let authCache: AuthUser | null = null;

export const authResolver: ResolveFn<AuthUser> = (route, state) => {
  const http: HttpClient = inject(HttpClient);
  const loaderService = inject(LoaderService);

  if (authCache !== null) {
    return of(authCache);
  }

  loaderService.show();
  
  return http.get<AuthUser>(`${environment.apiUrl}/auth`).pipe(
    tap(data => {
      authCache = data;
    }),
    finalize(() => {
      loaderService.hide();
    })
  );
};
